import FallbackLoading from '../components/FallbackLoading';
import Footer from '../components/layout/Footer';
import Preloader from '../components/Preloader';
import { lazy, Suspense } from 'react';
const TopNavigationBarPage = lazy(() => import('../components/layout/TopNavigationBar/page'));
const VerticalNavigationBar = lazy(() => import('../components/layout/VerticalNavigationBar/page'));
const AdminLayout = ({
  children
}) => {
  return <>
    {/* Keyboard users can jump past the top bar and menu straight to the page. */}
    <a href="#main-content" className="skip-link">Skip to content</a>
    <div className="wrapper">
      <Suspense fallback={<FallbackLoading />}>
        <TopNavigationBarPage />
      </Suspense>

      <Suspense fallback={<FallbackLoading />}>
        <VerticalNavigationBar />
      </Suspense>

      <main id="main-content" className="page-content" tabIndex={-1}>
        <div className="page-container">
          <Suspense fallback={<Preloader />}>{children}</Suspense>
        </div>
        <Footer />
      </main>
    </div>
  </>;
};
export default AdminLayout;